import React from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import "./styles.scss";
import { iconNavigation } from "../../../constants/iconNavigation";
import { useTheme } from "../../../hook/useThemes";
import { activeEventFathom } from "../../../utils/utils";

export const LINK = [
  {
    to: "/",
    title: "Play",
    key: "Menu-Play",
  },
  {
    to: "/results",
    title: "Results",
    key: "Menu-Results",
  },
  {
    to: "/history",
    title: "History",
    key: "Menu-History",
  },
  {
    to: "/chart",
    title: "Chart",
    key: "Menu-Chart",
  },
];

function NavigationBar() {
  const { pathname } = useLocation();
  const { operatorId, lang } = useTheme();

  return (
    <div className="wrapper-navigation-bar">
      {LINK.map((item) => {
        return (
          <Link
            to={`${item.to}${window.location.search}`}
            key={item.title}
            onClick={() => activeEventFathom(item.key)}
          >
            <div
              className={`item-navigation ${
                item?.to === pathname && "is-select"
              }`}
            >
              {iconNavigation?.[`${operatorId || 1}`]?.[item?.to]}
              <p className="title-navigation">
                {lang[`${item.title}`.toLowerCase()] || item.title}
              </p>
            </div>
          </Link>
        );
      })}
    </div>
  );
}

export default NavigationBar;
